import { Component, OnInit } from '@angular/core';
import { Category, Petition } from '@ncessor/shared';
import { NcessorService } from '../services/ncessor.service';
import { MessageService } from '../services/message.service';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { RouteReuseStrategy } from '@angular/router';
import { LoadingOverlayComponent } from '../loading-overlay/loading-overlay.component';
import { MatList, MatListItem } from '@angular/material/list';
import { NgFor } from '@angular/common';
import { CategorySubheaderComponent } from './category-subheader/category-subheader.component';
import { PetitionSummaryComponent } from './petition-summary/petition-summary.component';

@Component({
  selector: 'app-petitions',
  templateUrl: './petitions-page.component.html',
  styleUrls: ['./petitions-page.scss'],
  imports: [
    LoadingOverlayComponent,
    MatList,
    NgFor,
    CategorySubheaderComponent,
    MatListItem,
    PetitionSummaryComponent,
  ],
})
export class PetitionsPageComponent implements OnInit {
  petitions: Petition[] = [];
  categories: Category[] = [];
  isLoading$ = new BehaviorSubject<boolean>(false);

  constructor(
    public dialog: MatDialog,
    private ncessorService: NcessorService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.updatePetitions();
    this.ncessorService.getCategories().subscribe((result: Category[]) => {
      this.categories = result;
    });
  }

  getPetitionsOfCategory(category?: Category) {
    const filteredPetitions = this.petitions.filter((pet) => {
      return category ? pet.category === category._id : !pet.category;
    });
    return filteredPetitions;
  }

  private updatePetitions() {
    this.isLoading$.next(true);
    this.ncessorService.getPetitions({ state: 'active' }).subscribe((result: Petition[]) => {
      this.messageService.logNormal(`Updated petitions: ${result.length} items`);
      this.petitions = result;
      this.isLoading$.next(false);
    });
  }
}
